<!-- Account Restricted Dialog -->
<div id="st_login_backdrop" class="st-dialog-backdrop" *ngIf="showAccountRestrictedDialog">
  <div id="st_login_restricted_dialog" class="st-restricted-dialog p-4">
    <img alt="" src="assets/accout-restricted.png" [attr.alt]="'account_restricted' | translate" class="st-restricted-img" />
    <h5 class="st-restricted-title fs-18 fw-bold mb-2">{{ 'account_restricted' | translate }}</h5>
    <p class="st-restricted-msg fs-13 fw-normal" [ngClass]="{'mb-2': restrictedReason, 'mb-0': !restrictedReason}">{{
      'account_restricted_msg_prefix' | translate }}<span *ngIf="footerSupportEmail"
        class="st-restricted-email fw-semibold"> ({{ footerSupportEmail }})</span>{{ 'account_restricted_msg_suffix' |
      translate }}</p>
    <p class="st-restricted-reason fs-12 fw-normal mb-3" *ngIf="restrictedReason">
      <strong class="fw-semibold">{{ 'reason' | translate }}:</strong> {{ restrictedReason }}
    </p>
    <button class="st-restricted-btn fs-13 fw-semibold py-2 px-4" (click)="showAccountRestrictedDialog = false">{{
      'close' | translate }}</button>
  </div>
</div>

<div id="st_login_container" class="login_container">
  <div id="st_login_flex_container" class="flex-container d-flex">

    <div id="st_login_company_detail" class="company_detail">
      <div id="st_login_box" class="login_box d-flex flex-column justify-content-start">
        <div id="st_login_bg_decor" class="auth-bg-decor" aria-hidden="true">
          <div class="auth-bg-glow"></div>
          <div class="auth-bg-dots"></div>
          <svg class="auth-bg-waves" viewBox="0 0 400 240" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="authWaveGradient1" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" class="auth-wave-stop-start-1" />
                <stop offset="100%" class="auth-wave-stop-end" />
              </linearGradient>
              <linearGradient id="authWaveGradient2" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" class="auth-wave-stop-start-2" />
                <stop offset="100%" class="auth-wave-stop-end" />
              </linearGradient>
              <linearGradient id="authWaveGradient3" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" class="auth-wave-stop-start-3" />
                <stop offset="100%" class="auth-wave-stop-end" />
              </linearGradient>
            </defs>
            <path class="auth-wave-fill-1"
              d="M-20 150 C 40 120, 90 170, 150 145 C 210 120, 260 165, 320 140 C 360 122, 390 132, 420 150 L 420 240 L -20 240 Z" />
            <path class="auth-wave-fill-2"
              d="M-20 172 C 45 148, 95 190, 155 168 C 215 146, 265 185, 325 165 C 365 150, 392 158, 420 172 L 420 240 L -20 240 Z" />
            <path class="auth-wave-fill-3"
              d="M-20 196 C 50 175, 100 210, 160 192 C 220 174, 270 208, 330 190 C 368 176, 394 182, 420 196 L 420 240 L -20 240 Z" />
            <path class="auth-wave-line"
              d="M-20 168 C 45 144, 95 186, 155 164 C 215 142, 265 181, 325 161 C 365 146, 392 154, 420 168" />
            <path class="auth-wave-line auth-wave-line-2"
              d="M-20 190 C 50 169, 100 204, 160 186 C 220 168, 270 202, 330 184 C 368 170, 394 176, 420 190" />
          </svg>
        </div>
        <div id="st_login_brand_img" class="auth-wave-header">
          <div class="brand_img">
            <img *ngIf="!is_dark" [src]="loginSidebarLogoLight" alt="logo_dark"
              [width]="tenant_name == 'switz' ? '254' : (tenant_name == 'sbtf' ? '130' : '150')" />
            <img *ngIf="is_dark" [src]="logo_light" alt="logo_dark"
              [width]="tenant_name == 'switz' ? '254' : (tenant_name == 'sbtf' ? '130' : '150')" />
          </div>
          <button type="button" class="auth-close-btn" (click)="closeDialog()" [attr.aria-label]="'close' | translate">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div id="st_login_box_header" class="box_header">
          <p class="login-welcome-title fs-32 fw-bold mb-0">
            {{ 'welcome_back' | translate }} <span class="login-welcome-accent">{{ 'welcome_back_accent' | translate }}</span>
          </p>
          <p class="login-welcome-subtitle fs-14 fw-normal mt-1 mb-0">{{ 'sign_in_subtitle' | translate }}</p>
          <div class="auth-info-box gap-2 p-3 mt-3 mb-0">
            <i class="bi bi-info-circle fs-14"></i>
            <span class="login-helper-text fs-14 fw-normal">
              {{ 'signing_in_first_time_prefix' | translate }}{{ 'forgot_password_link_text' | translate }}{{
              'signing_in_first_time_suffix' | translate }}
            </span>
          </div>
        </div>
        <form (ngSubmit)="login()">
          
          <div id="st_login_form_wrapper">
            <div id="st_login_box_detail" class="box_detail mt-4" [formGroup]="_formGroupDynamic">
              <div [id]="'st_login_email_wrapper' + i" class="email"
                *ngFor="let item of total_fields; let i = index; trackBy: trackByFieldId">
                <div [id]="'st_login_email_type' + i" *ngIf="item.field.type == 'email'">
                  <mat-label [id]="'st_login_email_label' + i" [ngClass]="{ 'label-focused': inputFocused[item.id] }">{{
                    'email_or_id' | translate }}</mat-label>
                  <input [placeholder]="'enter_email_or_id' | translate" id="st_login_email_input"
                    class="full_width_input" type="text" (focus)="inputFocused[item.id] = true"
                    (blur)="inputFocused[item.id] = false" [formControlName]="item.id" [ngClass]="{
                      'st-invalid-shake':
                        _isSubmit &&
                        _formGroupDynamic.controls[item.id].hasError(
                          'required'
                        ),
                      'blue-border': inputFocused[item.id]
                    }" />
                </div>
                <div [id]="'st_login_text_type' + i" *ngIf="item.field.type == 'text'">
                  <mat-label [id]="'st_login_text_label' + i" [ngClass]="{ 'label-focused': inputFocused[item.id] }">{{
                    item.field.name | translate
                    }}</mat-label>
                  <input id="st_login_text_input" class="full_width_input" type="text"
                    (focus)="inputFocused[item.id] = true" (blur)="inputFocused[item.id] = false"
                    [formControlName]="item.id" [ngClass]="{
                      'st-invalid-shake':
                        _isSubmit &&
                        _formGroupDynamic.controls[item.id].hasError(
                          'required'
                        ),
                      'blue-border': inputFocused[item.id]
                    }" />
                </div>
                <div [id]="'st_login_pwd_wrapper' + i" *ngIf="total_fields.length > 0">
                  <div [id]="'st_login_pwd_inner' + i" *ngIf="item.field.type == 'password'">
                    <mat-label [id]="'st_login_pwd_label' + i" [ngClass]="{ 'label-focused': inputFocused[item.id] }">{{
                      item.field.name | translate
                      }}</mat-label>
                    <div [id]="'st_login_pwd_field' + i" class="st-password-field position-relative">
                      <input id="st_login_password_input" class="full_width_input" #input [type]="input_type"
                        [placeholder]="'Password' | translate" (focus)="inputFocused[item.id] = true"
                        (blur)="inputFocused[item.id] = false" [formControlName]="item.id" [ngClass]="{
                          'st-invalid-shake':
                            _isSubmit &&
                            _formGroupDynamic.controls[item.id]?.hasError(
                              'required'
                            ),
                          'blue-border': inputFocused[item.id]
                        }" />
                      <button type="button" class="st-btn-unstyled" (click)="showPassword(input.type)"><i [ngClass]="{
                          'bi-eye-slash': is_password,
                          'bi-eye-fill': !is_password
                        }" class="bi fs-14 st-pointer position-absolute st-password-toggle-icon"></i></button>
                    </div>
                  </div>
                </div>

                <div [id]="'st_login_error' + i" class="error-txt-msg fs-11 mb-2 mt-0" *ngIf="
                    _isSubmit &&
                    _formGroupDynamic.controls[item.id].hasError('required')
                  " style="color: red">
                  <span style="color: red">*</span>{{ 'required' | translate }}
                </div>
                
              </div>
              <div id="st_login_forgot_pwd_wrapper">
                <div id="st_login_forgot_password" class="forgot_password flex-e my-3"
                  *ngIf="total_fields[0]?.field['type'] == 'email'">
                  <button type="button" id="login_forgot_password_text"
                    class="st-btn-unstyled login-inline-link p-links fs-13 fw-medium mt-2" (click)="navigateToFrgt()">
                    {{ 'forgot_password' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="st_login_btn_wrapper" class="mt-2 flex-vc flex-column">
            <button id="login_proceed_button" type="submit" class="flex-hc flex-vc gap-2 fs-14 fw-semibold proceed_but"
              [disabled]="valid_form" [ngClass]="
                valid_form
                  ? 'disable_login_btn'
                  : _formGroupDynamic.invalid && valid_form
                  ? 'st-disableBtn'
                  : ''
              ">
              {{ 'login' | translate }}
            </button>
            <p *ngIf="false" class="text-secondary mt-2 bottom-section-text">
              {{ 'app.termsAgreement' | translate }}
              <a style="color: var(--sch_highlight_score)">{{ 'terms_and_privacy_policy' | translate }}</a>
            </p>
          </div>
        </form>
        <div id="st_login_signup_wrapper" *ngIf="show_sign_up"
          class="bottom_section mt-3 d-flex justify-content-center align-items-center">
          <p class="login-helper-text text-center mb-0 fs-13 fw-semibold">
            {{ 'new_user_click' | translate }}
            <a id="login_singup_text" class="login-inline-link p-links" (click)="navigateToSignUp()" (keydown.enter)="navigateToSignUp()" (keydown.space)="$event.preventDefault(); navigateToSignUp()" tabindex="0">
              {{ 'signUp' | translate }}
            </a>
            {{ 'to_create_your_account' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>